/*
 * Field Category Form Messages
 *
 * This contains all the text for the Field Category Form component.
 */

import { defineMessages } from 'react-intl';
export const scope =
  'src.pages.SetupPage.components.FieldCategories.components.FieldCategoryForm';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Field Category',
  },
  createButton: {
    id: `${scope}.createButton`,
    defaultMessage: 'Create new field',
  },
  editTooltip: {
    id: `${scope}.editTooltip`,
    defaultMessage: 'Edit',
  },
  positionLabel: {
    id: `${scope}.positionLabel`,
    defaultMessage: 'Position',
  },
  nameEnLabel: {
    id: `${scope}.nameEnLabel`,
    defaultMessage: 'Name EN',
  },
  nameDeLabel: {
    id: `${scope}.nameDeLabel`,
    defaultMessage: 'Name DE',
  },
  shownToUsers: {
    id: `${scope}.shownToUsers`,
    defaultMessage: '(shown to users)',
  },
});
